import React, { useEffect } from 'react';
import { Button, Form, Input, Select } from 'antd';

interface Props {
  onSearch: (filters: { name?: string; types?: string[] }) => void;
  rampTypes?: string[];
  defaultName?: string;
  defaultTypes?: string[];
}

const { Option } = Select;

const SearchRamps: React.FC<Props> = ({ onSearch, rampTypes = [], defaultName = '', defaultTypes = [] }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({ rampName: defaultName, rampTypes: defaultTypes });
  }, [defaultName, defaultTypes]);

  const submit = (values: any) => {
    onSearch({ name: values.rampName || '', types: values.rampTypes || [] });
  };

  return (
    <div className='search-container'>
      <Form form={form} layout='inline' onFinish={submit} className='search-form'>
        <Form.Item name='rampName' style={{ flex: 1 }}>
          <Input placeholder='Ramp Name' allowClear />
        </Form.Item>
        <Form.Item name='rampTypes'>
          <Select
            allowClear
            showArrow
            mode={'multiple'}
            maxTagCount={'responsive'}
            placeholder='Ramp Type'
            style={{ minWidth: 220 }}
          >
            {rampTypes.map((t) => (
              <Option key={t} value={t}>
                {t}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item className='search-btn'>
          <Button type='primary' htmlType='submit'>
            SEARCH
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default SearchRamps;
